import type { FaireProductEntity } from "../../entity_types/product";

export const p_neduxzf5d2: FaireProductEntity = {
  token: "p_neduxzf5d2",
  type: "product",
  name: "Rose of Jericho Doradilla Flower",
  brandToken: "b_nwecvb9e2v",
  brandName: "Enchanted Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/f3b2688a6df9cc0770f967ac0dc3cd6d61e42557c758e9ef668e8e0f1ce41265.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3832c41cde4d4fcddf4b85e93f32623a3a86edaf6ae87e78260af102f163afb7.png",
    "https://cdn.faire.com/fastly/2284ffc6ac0f512d66993b9f0e81c9c1821eae1660cbe3cc3bcf589f5bb61eaa.png",
    "https://cdn.faire.com/fastly/c478c04a1867733dabd74d175658729fbe6bc2a12b38e2eac3b8868e9acf492f.png",
  ],
  priceDollars: 3.45,
  description:
    "The Rose of Jericho, also known as the Resurrection Plant, is a symbol of renewal and rebirth. Native to the deserts of the Middle East and North Africa, this remarkable plant appears lifeless when dry — but place it in water, and it miraculously unfurls into vibrant green life. Historically used in spiritual practices for prosperity, protection, and new beginnings, it’s believed to absorb negative energy and bring blessings to the home. Whether for ritual work or as a living reminder of resilience, the Rose of Jericho is a powerful, timeless addition to your sacred space.\n\nSold for spells & rituals only. Not sold for human consumption.\n\nSizes may vary naturally, as each plant is unique.\n",
  tags: [],
  msrpDollars: 6.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:14.660Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
